import { User } from './user';

interface AwsGroup {
    GroupName: string;
    Precedence: number;
}

export class Group {
    Name: string;
    Precedence: number;
    Users: User[] = [];

    constructor(data: AwsGroup) {
        this.Name = data.GroupName;
        this.Precedence = data.Precedence;
    }
}
